module.exports = __webpack_public_path__ + "img/捂脸.42b9b142.png";